import _ from 'lodash';
import { fromJsonArray } from 'src/core/utils';
import CustomerData from 'src/entities/customer/CustomerData';
import { CustomerFeedback } from 'src/entities/customer/CustomerFeedback';
import CustomerMailAddress from 'src/entities/customer/CustomerMailAddress';
import CustomerPhoneNumber from 'src/entities/customer/CustomerPhoneNumber';
import { entityCollectionDefaultState, EntityCollectionState } from 'src/store/entities/types/EntityCollectionState';
import { singleEntityDefaultState, SingleEntityState } from 'src/store/entities/types/SingleEntityState';

/* Customer Mail Addresses */
export const getCustomerMailAddresses = (state: any): EntityCollectionState<CustomerMailAddress> => {
    const data = state.customerMailAddresses;
    if (_.isEmpty(data)) return entityCollectionDefaultState<CustomerMailAddress>();

    return {
        isFetching: data.isFetching,
        error: data.error,
        items: fromJsonArray(CustomerMailAddress, data.items),
    };
};

/* Customer Phone Numbers */
export const getCustomerPhoneNumbers = (state: any): EntityCollectionState<CustomerPhoneNumber> => {
    const data = state.customerPhoneNumbers;
    if (_.isEmpty(data)) return entityCollectionDefaultState<CustomerPhoneNumber>();

    return {
        isFetching: data.isFetching,
        error: data.error,
        items: fromJsonArray(CustomerPhoneNumber, data.items),
    };
};

/* Customer Data */
export const getCustomerData = (state: any): SingleEntityState<CustomerData> => {
    const data = state.customerData;
    if (_.isEmpty(data)) return singleEntityDefaultState<CustomerData>();

    return {
        isFetching: data.isFetching,
        error: data.error,
        content: data.content ? new CustomerData(data.content) : undefined,
    };
};

/* Customer Feedback */
export const getCustomerFeedback = (state: any): SingleEntityState<CustomerFeedback> => {
    const data = state.customerFeedback;
    if (_.isEmpty(data)) return entityCollectionDefaultState();

    return {
        isFetching: data.isFetching,
        error: data.error,
        content: data.content ? new CustomerFeedback(data.content) : undefined,
    };
};
